/**
 * Étapes du guide “Battle viewers” (HUD PV) pour OBS.
 * @module config/battleViewersGuideSteps
 */

/**
 * Paramètre d’URL du lecteur d’overlay (`/overlay-player`) pour prévisualiser le décompte d’inscription (durée en secondes).
 * Ex. `?battleCountdownPreview=90` — sans battle réelle, utile pour caler la mise en page dans OBS.
 */
export const BATTLE_OVERLAY_COUNTDOWN_PREVIEW_QUERY = 'battleCountdownPreview';

/** Plafond secondes pour le preview URL (évite valeurs absurdes). */
export const BATTLE_OVERLAY_COUNTDOWN_PREVIEW_MAX_SEC = 3600;

/** Titre / coût par défaut pour la récompense Channel Points “Battle viewers” (détectée par le bot si le titre contient “battle”). */
export const BATTLE_VIEWERS_DEFAULT_REWARD_TITLE = 'Battle viewers';
export const BATTLE_VIEWERS_DEFAULT_REWARD_COST = 8000;
export const BATTLE_VIEWERS_DEFAULT_REWARD_PROMPT =
  'Lance une battle sur le stream : choisis ton camp avec !equipe1 ou !equipe2, puis !1 pour attaquer et !2 pour soigner ton équipe.';

/**
 * @param {string} frontendOrigin
 * @returns {Array<{ id: string, shortLabel: string, title: string, description: string, obsUrl?: string, copyMessage?: string }>}
 */
export function buildBattleViewersGuideSteps(frontendOrigin) {
  const base = (frontendOrigin || '').replace(/\/$/, '');
  const overlayUrl = base ? `${base}/overlay-player` : '/overlay-player';

  return [
    {
      id: 'enable-feature',
      shortLabel: 'Activer',
      title: 'Activer “Battle viewers” dans les paramètres',
      description:
        'Dans Paramètres → Paramètres avancés : active “Battle viewers”. (Fonction Premium / essai).',
    },
    {
      id: 'obs-url',
      shortLabel: 'OBS',
      title: 'Ajouter l’Overlay Player dans OBS',
      description:
        'Dans OBS, ajoute une source Navigateur qui pointe vers le lecteur d’overlays. Le HUD battle apparaîtra au-dessus du stream.',
      obsUrl: overlayUrl,
      copyMessage: 'URL copiée !',
    },
    {
      id: 'reward',
      shortLabel: 'Reward',
      title: 'Créer la récompense “Battle viewers”',
      description:
        'Le bot reconnaît une récompense dont le titre contient “battle” (ex. “Battle viewers”). Tu peux la créer en un clic avec le bouton ci-dessous (8000 Channel Points par défaut), ou manuellement sur Twitch.',
    },
    {
      id: 'commands',
      shortLabel: 'Commandes',
      title: 'Commandes pendant la battle',
      description:
        'Les viewers rejoignent une équipe avec !equipe1 / !equipe2, puis jouent avec !1 (attaque) / !2 (soin).',
    },
    {
      id: 'test',
      shortLabel: 'Test',
      title: 'Tester le HUD (sans reward)',
      description:
        'Utilise les boutons de test pour démarrer une battle et faire bouger les PV dans OBS. ' +
        `La durée du décompte d’inscription (récompense live) se règle dans Paramètres → Paramètres avancés → Battle viewers. ` +
        `Pour prévisualiser uniquement le décompte dans OBS sans battle : ?${BATTLE_OVERLAY_COUNTDOWN_PREVIEW_QUERY}=120 (secondes).`,
    },
  ];
}

